export function formatDayISO(day) {
  const date = day instanceof Date ? day : new Date(day);
  const utcDate = new Date(Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds()
  ));
  return utcDate.toISOString();
}

export function getActivityUserIds(activity) {
  if (!activity?.users || !Array.isArray(activity.users)) {
    return [];
  }
  return [...new Set(activity.users.filter(Boolean))];
}

export function formatActivityDate(startDate) {
  const date = startDate instanceof Date ? startDate : new Date(startDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function isRecurringSkipMarker(activity) {
  return Boolean(activity?.cancelled && activity?.relatedActivity && activity?.startDate);
}

export function buildRecurringSkipMarker(template, day) {
  const dayDate = day instanceof Date ? day : new Date(day);
  return {
    name: template.name,
    startTime: template.startTime,
    endTime: template.endTime || '',
    startDate: formatActivityDate(dayDate),
    consumequota: template.consumequota,
    cupos: template.cupos,
    registration: false,
    planningId: template.planningId,
    stablishmentId: template.stablishmentId,
    day: template.day,
    relatedActivity: template._id,
    cancelled: true,
  };
}

export function hasSkipMarkerForDate(activities, templateId, day) {
  const dateStr = formatActivityDate(day);
  return activities.some((activity) => {
    if (!isRecurringSkipMarker(activity)) return false;
    if (activity.relatedActivity !== templateId) return false;
    return formatActivityDate(activity.startDate) === dateStr;
  });
}
